import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import { Navigate } from 'react-router';

// login option 3 routing
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const AuthRegister3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));
const Auth = Loadable(lazy(() => import('views/pages/authentication/auth-forms/Auth')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/',
            element: <AuthLogin3 />
        },
        {
            path: '/autenticacion',
            element: <Auth />
        },
        {
            path: '/pages/register/register3',
            element: <AuthRegister3 />
        },
        { path: '*', element: <Navigate to="/" /> }
    ]
};

export default AuthenticationRoutes;
